/******************************************************************************************
 * Renwal Order Constants
 *******************************************************************************************
 *
 * RENEWAL are the usual kind of renewal orders
 * RETURN orders return part or all of a prior renewal order
 *
 */
(function() {
  

  angular.module('rcServices.renewalOrder', []).constant('RENEWAL_ORDER', {
    STATUS: {
      RENEWAL: 'RENEWAL',
      RETURN: 'RETURN'
    }
  });
})();
